<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <v-form ref="form" @submit.prevent="handleSubmit">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="اطلاعات پرداخت">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex >
                                            <v-autocomplete
                                                    label="خرید"
                                                    :items="baskets"
                                                    v-model="form.basket_id"
                                                    autocomplete
                                                    auto
                                                    required
                                                    @change="setAmount"
                                                    item-text="name"
                                                    item-value="basket_id"
                                                    :rules="[rules.required]"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex >
                                            <v-autocomplete
                                                    label="درگاه پرداخت"
                                                    :items="gateways"
                                                    v-model="form.gateway_id"
                                                    autocomplete
                                                    auto
                                                    required
                                                    item-text="name"
                                                    item-value="id"
                                                    :rules="[rules.required]"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex >
                                            <v-tooltip bottom>
                                                <v-text-field
                                                        slot="activator"
                                                        label="مبلغ (ریال)"
                                                        name="amount"
                                                        v-model.number="form.amount"
                                                        data-number
                                                        type="text"
                                                        :rules="[rules.required]"
                                                ></v-text-field>
                                                <span>{{toPersian(form.amount)}}</span>
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout><v-layout>
                                    <v-flex >
                                        <v-text-field
                                                label="شماره تراکنش"
                                                name="transaction_id"
                                                v-model="form.transaction_id"
                                                type="text"
                                                data-ltr
                                        ></v-text-field>
                                    </v-flex>

                                </v-layout><v-layout>
                                </v-layout>
                                    <v-layout>
                                        <v-btn
                                                :loading="loading"
                                                :disabled="loading"
                                                color="green"
                                                class="white--text"
                                                large
                                                type="submit"
                                        >
                                            ثبت
                                            &nbsp;
                                            <v-icon left dark>save</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false"><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
export default {
  components: {
    VWidget
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      form: {
        basket_id: 0,
        gateway_id: 0,
        amount: 0,
        transaction_id: '',
      },
      stores: [],
      baskets: [],
      gateways_data: [],
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {
    gateways () {
      const basket = this.baskets.find(b => b.basket_id === this.form.basket_id);
      if (typeof basket === 'undefined') {
        return [];
      }

      return this.gateways_data.filter(gd => gd.store_id === basket.shop_id);
    }
  },
  watch: {},
  mounted: function () {
    this.getGateways();
    this.getBaskets();
  },
  methods: {
    setAmount: function () {
      this.form.amount = this.baskets.find(b => b.basket_id === this.form.basket_id).total;
    },
    getBaskets: function () {
      this.axios.get('/reseller/customer_baskets/?is_paid=N')
        .then(response => {
          this.baskets = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    getGateways: function () {
      this.axios.get('/reseller/payment_gateways/')
        .then(response => {
          this.gateways_data = response.data.data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    handleSubmit () {
      this.$validator.validateAll().then((isValidate) => {
        if (isValidate) {
          this.loader = 'loading';
          this.axios.post('/reseller/submit_manual_payment', this.form)
            .then(response => {
              // Response Submit Method
              console.log(response);
              this.snackbar.text = 'با موفقیت انجام شد.';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'success';
              this.snackbar.snackbar = true;
              this.loading = false;
              this.$refs.form.reset();
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
              this.loading = false;
            });
        }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/manual_payment/add.vue